import React from "react"
import Signup from "./auth/Signup"
//import { Container } from "react-bootstrap"
import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Dashboard from "./dashboard/Dashboard"
import Login from "./auth/Login"
import PrivateRoute from "./PrivateRoute"
import ForgotPassword from "./auth/ForgotPassword"
import UpdateProfile from "./auth/UpdateProfile"
import EntityDetails from "./entities/EntityDetails"
import CreateEntity from "./entities/CreateEntity"
import UpdateEntity from "./entities/UpdateEntity"
import Navbar from "./layout/Navbar"
import "./App.css"
import { styles } from "./layout/styles"
import ChatGPT from "./dashboard/chatgpt"
import WellnessWizard from "./entities/WellnessWizard"
import CompleteWellnessReport from "./layout/WellnessReport/CompleteWellnessReport"

function App() {
  return (
      // <Container className="d-flex align-items-center justify-content-center" style={{ minHeight:"80vh"}}>
        //<div className="w-100" style={styles.MainBGDiv}>
          <Router>
            <AuthProvider>
              <Navbar/>
              <Routes>
                <Route exact path="/" element={<PrivateRoute><Dashboard/></PrivateRoute>}/>
                <Route path="/updateProfile" element={<PrivateRoute><UpdateProfile/></PrivateRoute>}/>
                <Route path="/signup" element={<Signup/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/forgotPassword" element={<ForgotPassword/>}/>
                <Route path="/entitydetails/:id" element={<PrivateRoute><EntityDetails/></PrivateRoute>}/>
                <Route path="/createentity" element={<PrivateRoute><CreateEntity/></PrivateRoute>}/>
                <Route path="/updateentity/:id" element={<PrivateRoute><UpdateEntity/></PrivateRoute>}/>
                <Route path="/chatgpt" element={<PrivateRoute><ChatGPT/></PrivateRoute>}/>
                <Route path="/initiatewellness/:id" element={<PrivateRoute><WellnessWizard/></PrivateRoute>}/>
                <Route path="/wellnessreport" element={<PrivateRoute><CompleteWellnessReport/></PrivateRoute>}/>
              </Routes>
            </AuthProvider>
          </Router>
        //</div>
      // </Container> }
  )
}

export default App;

